import { useState } from 'react'
import { supabase } from '../supabaseClient'

export default function SearchByPatente() {
  const [patente, setPatente] = useState('')
  const [results, setResults] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const buscar = async () => {
    setLoading(true)
    setError('')
    setResults([])

    const { data, error } = await supabase
      .from('services')
      .select('*')
      .ilike('patente', `%${patente.trim()}%`)
      .order('fecha_service', { ascending: false })

    if (error) {
      setError(error.message)
    } else {
      setResults(data)
    }

    setLoading(false)
  }

  return (
    <div className="page-container">
      <h2>🔎 Consultar historial por patente</h2>

      <div className="form-section">
        <input
          type="text"
          className="input"
          placeholder="Ingresá una patente"
          value={patente}
          onChange={e => setPatente(e.target.value)}
        />
        <button
          className="button"
          onClick={buscar}
          disabled={loading || !patente.trim()}
        >
          Buscar
        </button>
      </div>

      {loading && <p className="loading">⏳ Buscando...</p>}
      {error && <p className="error">❌ {error}</p>}
      {results.length === 0 && !loading && patente && (
        <p className="info-text">No se encontraron resultados.</p>
      )}

      {results.length > 0 && (
        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Patente</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>KM</th>
                <th>Lubricante</th>
              </tr>
            </thead>
            <tbody>
              {results.map((s) => (
                <tr key={s.id}>
                  <td>{s.fecha_service}</td>
                  <td>{s.patente}</td>
                  <td>{s.marca}</td>
                  <td>{s.modelo}</td>
                  <td>{s.km}</td>
                  <td>{s.lubricante}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}